"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";
import { useEffect } from "react";

// Mute the React 19 warning about inline script tags for next-themes.
// next-themes uses an inline script to prevent FOUC, which is correct and safe,
// but React 19 logs a strict warning about all inline scripts evaluated on the client.
if (typeof window !== "undefined") {
  const originalError = console.error;
  console.error = (...args) => {
    const msg = typeof args[0] === "string" ? args[0] : "";
    if (
      msg.includes("Encountered a script tag while rendering React component")
    ) {
      return;
    }
    originalError.apply(console, args);
  };
}

export function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof NextThemesProvider>) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
